// extracted by mini-css-extract-plugin
export default {"config":"Config_config__pgPGI"};